
import { IStoreState } from "@montana/store/store";
import { generateContainer, IContainerProps } from "../base/generate-container";
import { IProductContainerState } from "./product";
import {
    applyProductConfig,
    setProduct,
    setProductPrices,
    initProduct,
    updateProductConfig,
    updateProductVariant,
    setProductCylindoImage,
    clearProductState,
    setProductImageUpdating,
    setProductPriceUpdating,
    setARUrl,
    setARAvailability
} from "./product.actions";

const mapState = ({ product }: IStoreState): IProductContainerState => ({ ...product });

const actions = {
    applyProductConfig,
    setProduct,
    setProductPrices,
    initProduct,
    updateProductConfig,
    updateProductVariant,
    setProductCylindoImage,
    clearProductState,
    setProductImageUpdating,
    setProductPriceUpdating,
    setARUrl,
    setARAvailability
};

export type IProductContainerProps = IContainerProps<ReturnType<typeof mapState>, typeof actions>;

export const [ProductContainer, connectWithProduct, useProduct] = generateContainer(mapState, actions);
